export default __webpack_public_path__ + "static/media/kitAlarma2.73b0fa40.png";